import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Divider } from 'antd';
import 'antd/dist/antd.css';

export default class AccountEmail extends Component {
  static propTypes = {
    accountData: PropTypes.object.isRequired,
    ivr: PropTypes.bool,
    byo: PropTypes.bool,
    selfInstall: PropTypes.bool,
    service: PropTypes.string.isRequired,
  };

  render() {
    const { accountData, byo, selfInstall, ivr } = this.props;
    const { devices, mainline, name, realm, users, menus } = accountData;
    const whatNext = (
      ( selfInstall && byo &&
        <p>
          You&apos;ll now be able to use the Voice Configuration settings below to configure your own phones and get up and running with Voyager Voice!
          <br /><br />
          If you&apos;re moving some existing phone numbers over to Voyager, then you&apos;ll receive an email shortly confirming the date this is scheduled to take place. Once your phone numbers have been moved over to Voyager, you&apos;ll be able to make and receive calls.
        </p>
      ) || ( selfInstall && !byo &&
        <p>
          We&apos;ve sent you some pre-configured Voyager phones, so when they arrive you simply need to connect them to your network via their Internet port.
          <br /><br />
          If you&apos;re moving some existing phone numbers to Voyager, then you&apos;ll receive an email shortly confirming the date this is scheduled to take place. Once your phone numbers have been moved over to Voyager, you&apos;ll be able to make and receive calls.
        </p>
      ) || <p>You&apos;re all set. There&apos;s nothing for you to do at this stage. Our installer will be in touch soon, if they haven&apos;t already, to arrange a time to visit your site and complete your phone install. The information here is for your reference only. </p>
    );

    const userColumns = [{
      title: 'Ext',
      dataIndex: 'extension',
      key: 'extension',
    }, {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    }, {
      title: 'DDI',
      dataIndex: 'ddi',
      key: 'ddi',
    }, {
      title: 'Username/Email',
      dataIndex: 'email',
      key: 'email',
    }, {
      title: 'Voicemail #',
      dataIndex: 'vmNum',
      key: 'vmNum',
    }];

    const deviceColumns = [
      {
        title: 'User',
        dataIndex: 'userName',
        key: 'userName',
      },
      {
        title: 'Device Name',
        dataIndex: 'deviceName',
        key: 'deviceName',
      },
      {
        title: 'MAC Address',
        dataIndex: 'deviceMac',
        key: 'deviceMac',
      },
      {
        title: 'Device Username',
        dataIndex: 'sipUsername',
        key: 'sipUsername'
      },
      {
        title: 'Device Password',
        dataIndex: 'sipPassword',
        key: 'sipPassword'
      },

    ];

    const menuColumns = [
      {
        title: 'Name',
        dataIndex: 'menuName',
        key: 'menyName',
      },
      {
        title: 'Record PIN',
        dataIndex: 'recordPin',
        key: 'recordPin',
      },
    ];

    return (
      <div>
        <h3>What Next?</h3>
        { whatNext }
        <h3>Account Details:</h3>
        <p>Main Number: { mainline || "Mainline not in use." }</p>
        <p>Account Name: { name }</p>
        { selfInstall && byo && <p>Account Realm: { realm }</p> }
        {
          ivr &&
          <div>
            <h3>Digital Receptionist</h3>
            Your account has been pre-configured with a digital receptionist. A menu greeting is played to callers, allowing a caller to select various extensions or departments to connect with.
            <br /><br />
            A voice greeting needs to be recorded for this service. You can email us a pre-recorded voice file for the greeting, or you can simply record one yourself over the phone by following the steps below.
            <br /><br />
            <ul>
              <li>Pick up a phone registered in this account.</li>
              <li>Dial your office main number.</li>
              {
                menus.length === 1
                  ? <li>Enter this PIN when prompted: { menus[0].recordPin }</li>
                  : <li> Enter the Record PIN </li>
              }
              <li>Record your greetings / menu.</li>
            </ul>
          </div>
        }
        {
          ivr && menus.length > 1 &&
          <Table dataSource={ menus } size="small" columns={ menuColumns } pagination={ false }></Table>
        }
        <h3>User Details:</h3>
        <Table dataSource={ users } size="small" columns={ userColumns } pagination={ false }></Table>
        {
          selfInstall && byo &&
          <div>
            <h3>Device Details</h3>
            <Table dataSource={ devices } size="small" columns={ deviceColumns } pagination={ false }></Table>
          </div>
        }
        <Divider />
        <h3>Voyager Voice Portal Access Instructions:</h3>
        We have created your new login which you can use to access the Voyager Voice Portal. Here you will be able to navigate between all your Voice Apps:
        <ul>
          <li>Go to: https://portal.voice.isx.nz/</li>
          <li>Enter your email address into the Username field:</li>
          <li>Enter your Account Name as above into then Account Name field</li>
          <li>Select &apos;Reset Password&apos;</li>
          <li>Follow the instructions via the email with a link to reset your password</li>
        </ul>
        Check out all of our user guides <a href="https://helpdesk.voyager.co.nz/index.php?/Knowledgebase/Article/View/263/56/voyager-voice-user-guides">here</a>.
      </div>
    );
  }
}
